module.exports = __webpack_public_path__ + "img/active-b.75c998a5.png";